import { render, staticRenderFns } from "./authorLeftMenu.vue?vue&type=template&id=dbe0f8be&scoped=true&"
import script from "./authorLeftMenu.vue?vue&type=script&lang=js&"
export * from "./authorLeftMenu.vue?vue&type=script&lang=js&"
import style0 from "./authorLeftMenu.vue?vue&type=style&index=0&id=dbe0f8be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe0f8be",
  null
  
)

export default component.exports